import { render, staticRenderFns } from "./RejectJob.vue?vue&type=template&id=b62f770e"
import script from "./RejectJob.vue?vue&type=script&lang=ts"
export * from "./RejectJob.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports